import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { NavigationStart, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { isSuperAdmin } from '../../guards/super-admin.guard';
import { ClubRequestsService } from '../../pages/club-requests/club-requests.service';
import { AccountRequestsService } from '../../pages/account-requests/account-requests.service';

/**
 * De onderbalk op de telefoon (eigenaar 15-10-2026, variant A).
 *
 * Op een iPhone staat de zijbalk niet: die is 280 px breed (ingeklapt 72) op
 * een scherm van 375 tot 440. Hier staan alleen de pagina's die op de
 * telefoon iets betekenen: hoe de vloot ervoor staat (Status = Clubstats),
 * de studio's, de pc's, en voor een super-admin de aanvragen. De rest -- rollen,
 * panelen, imports, licenties -- is invulwerk voor de computer en staat er
 * bewust niet.
 *
 * Alleen zichtbaar onder 767.98px; daarboven verbergt styles.scss hem en blijft
 * de zijbalk zoals hij was.
 */
@Component({
  selector: 'app-mobile-nav',
  standalone: true,
  imports: [NgIf, RouterLink, RouterLinkActive],
  templateUrl: './mobile-nav.component.html',
  styleUrls: ['./mobile-nav.component.scss'],
})
export class MobileNavComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly clubRequests = inject(ClubRequestsService);

  /** Openstaande clubaanvragen; de zijbalk houdt dit getal al bij. */
  public readonly aanvragen = this.clubRequests.pendingCount;
  /** Openstaande aanvragen vanaf het inlogscherm; ook bijgehouden door de zijbalk. */
  public readonly accountAanvragen = inject(AccountRequestsService).pendingCount;
  public superAdmin = false;
  /** Het blad onder "More". */
  public meerOpen = false;

  ngOnInit(): void {
    this.superAdmin = isSuperAdmin(this.authService.user);
    // Elke navigatie sluit het blad, ook een terug-veeg van iOS.
    this.router.events.pipe(
      filter(e => e instanceof NavigationStart),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(() => (this.meerOpen = false));
  }

  public onLogOut(): void {
    this.meerOpen = false;
    this.authService.logout();
    this.router.navigateByUrl('/login');
  }
}
